import { get, writable } from 'svelte/store'
import { country } from './index.js'
import { getCurrencyForCountry } from '$lib/utilities/getCurrencyForCountry'

export const createCurrency = () => {
    let initialValue = getCurrencyForCountry(get(country))

    return writable(initialValue)
}
